/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ExtractGroupBy = {
  UserId: "user_id",
  ApiKeyId: "api_key_id",
  Model: "model",
} as const;
export type ExtractGroupBy = ClosedEnum<typeof ExtractGroupBy>;

/** @internal */
export const ExtractGroupBy$inboundSchema: z.ZodNativeEnum<
  typeof ExtractGroupBy
> = z.nativeEnum(ExtractGroupBy);
/** @internal */
export const ExtractGroupBy$outboundSchema: z.ZodNativeEnum<
  typeof ExtractGroupBy
> = ExtractGroupBy$inboundSchema;
